<div class="dashletActivity">
  <span class="sw-icon sw-icon-new-point"></span>
  <div class="dashletActivity__text">
    {{ 'added_this_point' | ppTranslate }}
  </div>
</div>
